{
  "register-success-page": {
    "buttons": {
      "start": "Commençons"
    },
    "text": {
      "account-created": "Compte créé",
      "account-created-hint": "Votre compte est créé ! Vous pouvez maintenant vous connecter et profiter de notre système de réservation."
    }
  }
}
